import React from "react";
import { Link } from "react-router-dom";

const VerifyEmailAfterSignUp = () => {
  return (
    <div>
      <div className="successDiv">Account Created Successfully!</div>
      <div className="toProceed">
        Please verify your email to activate your account by clicking the link
        you have received from us.If you haven't received it please check the
        spam folder.
        <Link to="/SignIn" className="proceedLogin">
          Proceed To Sign In
        </Link>
      </div>
    </div>
  );
};

export default VerifyEmailAfterSignUp;